import { Corporate } from '../pages/dashboard/corporates/interface/DocDrawerProps';
import { Beneficiary } from '../pages/dashboard/payments/interfaces/Beneficiary';
import { Domains } from './Domains';

export interface User {
    has_business_type: boolean;
    country: string;
    booking: boolean;
    user_name: string;
    roles: string[];
    team_member_role_id: number;
    products: null;
    scope: string[];
    corporate_name: string;
    exp: number;
    first_name: string;
    user_email: string;
    address: string;
    corporate_status: number;
    last_name: string;
    has_business_industry: boolean;
    authorities: [string];
    user_id: string;
    corporate_id: number;
    name: string;
    user_level: number;
    phone_number: string;
    other_name: string;
    default_currency: string;
}

export interface ShippingProfile {
    annualShipmentTeu: string;
    blNumber: string;
    bookingNumber: string;
    bookingProfileId: number;
    businessName: string;
    contractNumber: string;
    corporateId: number;
    createdDate: string;
    customerNumber: string;
    firstName: string;
    id: number;
    lastName: string;
    requesterContactEmail: string;
    requesterContactNumber: string;
    shippingLineId: number;
    shippingLineName: string;
    status: number;
}

export interface BeneficiaryShippingLines {
    name: string;
    code: string;
    booking: number;
    shipping: number;
    beneficiary: Beneficiary;
}

export interface CurrentUserDocument {
    documentName: string;
    documentUrl: string;
    id: number;
    rejectionMessage: string;
    status: number;
}

export interface CurrentUserProfile {
    id?: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    role?: string;
    permissions: AccessPermissions;
    corporate: Corporate;
    documents: Array<CurrentUserDocument>;
    businessTypes: Array<string>;
    rejectionMessage?: string;
}

export type AccessPermissions = {
    [key in keyof Domains]: 'read' | 'write' | 'none' | '*';
};

export type PermissionKey =
    | 'logistics'
    | 'financing'
    | 'payments'
    | 'insurance'
    | 'sales'
    | 'tradeDocuments'
    | 'stocks'
    | 'treasuryManagement'
    | 'userManagement';

export interface UserPermissions {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    accessPermissions: AccessPermissions;
}

export interface Permission {
    logistics?: string;
    financing?: string;
    payments?: string;
    insurance?: string;
    sales?: string;
    stocks?: string;
    tradeDocuments?: string;
    userManagement?: string;
    treasuryManagement?: string;
}

export interface TeamMembers {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    accessPermissions: Permission;
    status: number;
    lastLoginDate: string;
    createdDate: string;
    corporateId: number;
}

export interface Role {
    id?: number;
    name: string;
    description: string;
    permissions: Permission;
    actionPermissions: Record<string, string>;
    corporateId?: number;
}

export const teamMemberStatusMap: Record<string, string> = {
    0: 'default',
    1: 'success',
    3: 'warning',
    2: 'error'
};

export const teamMemberStatusName: Record<number, string> = {
    1: 'Active',
    2: 'Inactive',
    3: 'Pending'
};
